import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// logs
// eslint-disable-next-line import/prefer-default-export
export async function getLogs(payload) {
  return requests
    .get(constants.API_URL_JOBS, `${urls.GET_JOBS_LOG}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// job configs
export async function getJobConfigs() {
  return requests
    .get(constants.API_URL_JOBS, urls.GET_JOB_CONFIGS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateJobCron(id, expresionCron) {
  return requests
    .put(constants.API_URL_JOBS, `${urls.PUT_JOB_CONFIG_CRON}/${id}/cron`, { expresionCron })
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function updateJobActivo(id, activo) {
  return requests
    .put(constants.API_URL_JOBS, `${urls.PUT_JOB_CONFIG_ACTIVO}/${id}/activo`, { activo })
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function getJobLogsPaginated(jobName, page = 1, pageSize = 10) {
  return requests
    .get(constants.API_URL_JOBS, `${urls.GET_JOB_LOGS_PAGINATED}/${jobName}?page=${page}&pageSize=${pageSize}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getJobCiclosPaginated(jobName, page = 1, pageSize = 10) {
  return requests
    .get(constants.API_URL_JOBS, `${urls.GET_JOB_CICLOS_PAGINATED}/${jobName}/ciclos?page=${page}&pageSize=${pageSize}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
